export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-10-16 at 14.36.49.092e9b7e.jpeg";